export default "__VITE_ASSET__CwKxKlVb__"